module.exports = "pegasus/assets/blocks/social-2-theme5.png";